import React from "react";
import DrOsterwalder from "../../../Images/DrOsterwalder.jpg";

const Text8 = () => {

  React.useEffect(() => {
    // 👇️ scroll to top on page load, behavior can be snappy with 'auto'
    document.getElementById('top')?.scrollIntoView({ behavior: 'smooth' });}
    , []);
    return(
      <>
        <p className="content-heading" id="top">
        Dina lönsamhetsnycklar  
      </p>
    
      <div className="content-text mt-4">

        <p>    
          Hur du tänker för att finna just dina nycklar till lönsamhet beror i hög grad på vad du säljer.                           
        </p>
        <ul>
          <li> <i>Egen Tid</i> - exempelvis konsult eller föreläsare </li>
          <li className="mt-1"> <i>Produkter</i> - egen tillverkning eller helt/delvis inköpta </li>
        </ul>

        <p className="heading2 mt-4">
          Sälja Egen Tid 
        </p>
        <p>
          Vid timdebitering är det i huvudsak två faktorer som påverkar din nettolön. 
        </p>
        <ol>
          <li> <i>Priset</i> du tar per timme alternativt per föreläsning </li>
          <li className="mt-2"> 
            <i>Beläggningsgraden</i>. Alltså hur stor del av faktisk arbetstid som du kan debitera kund och hur stor andel 
            du lägger på annat, som du inte kan ta betalt för.
          </li>
        </ol>

        <div className="ms-4">
          <p className="heading3 mt-4">
            Prissättning/Fakturering 
          </p>
          <p>
            <i>Vilken</i> tid tar du betalt för? Din verksamhet konsumerar tre slags tid  
          </p>
          <ol>
            <li> Faktisk tid du lägger på kunden </li>
            <li className="mt-2"> Tid du lagt på anpassning/förberedelser för just den kunden/föreläsningen </li>
            <li className="mt-2"> Lämplig del av all tid du lagt på att skapa tjänsten i grundutförande </li>
          </ol>
          <p>
            Tar du betalt för samtliga tre? Annars finns fin lönsamhet att utveckla ur din prismodell.
          </p>
          <p>
            Ju fler av veckans timmar du kan debitera på kund ju högre blir din lön. Ofta jobbas mer för en kund än vad som syns. 
            Även om marknaden kanske inte tål extra påslag kan du ändå söka få betalt för sådan - påvisbar - indirekt tid. 
          </p>
          <p>
            Vid arbete med tjänsteutveckling - notera antal timmar du lägger. Då är det bara att summera för att veta vad 
            utvecklingen hittills kostat. Dela den kostnaden med antalet gånger du bedömer tjänsten kan användas/levereras hos 
            betalande kund, så får du ett riktmärke för att fakturera utvecklingskostnaden - utslaget över tjänstens livstid. Så här:
          </p>
          <p>
            <i> (Antal arbetstimmar x timpris) / bedömt antal leveranser = utvecklingskostnad per leverans </i>
          </p>
          <p>
            Formeln kan användas både för kundanpassning/förberedelser (punkt två ovan) och för att fördela de grundläggande 
            utvecklingskostnaderna (punkt tre ovan). 
          </p>

          <p className="heading3 mt-4">
            Beläggningsgrad - hur du utnyttjar din tid  
          </p>
          <p>
            Ett sätt att få  klarhet i hur du använder tiden är att under ett par veckor 
          </p>
          <ol>
            <li> Notera (timme för timme, dag för dag) hur tiden disponeras </li>
            <li className="mt-2"> 
              Summera hur mycket tid du lagt på  
              <ul>
                <li className="mt-1"> Debitering på kund </li>
                <li className="mt-1"> Nödvändiga åtgärder som främjade din verksamhet </li>
                <li className="mt-1"> Annan ”onödig” tid </li>
              </ul>
            </li>
            <li className="mt-2"> Beräkna din Beläggningsgrad i procent (%) exempelvis </li>
            <p style={{width:'70%'}}>
              <i>
                (Summa debiterade timmar x 100) / samtliga noterade arbetstimmar 
                Exempel: (1250 tim x 100) / 1750 noterade tim = 71,4% Beläggningsgrad 
              </i>
            </p>
          </ol>
          <p>
            Vidta nödvändiga åtgärder om beläggningsgraden behöver höjas - alltså jobba mer med debiterbar verksamhet. 
            Exempelvis låt en redovisningsbyrå sköta bokföringen, och ägna mer tid åt sälj. 
          </p>
          <p className="strong" style={{marginBottom:'0px'}}> 
            Kommentar:
          </p>
          <p>
            Av årets 1750 normal-årstimmar är ett riktmärke en fakturerad beläggningsgrad på ca 70 - 75%  (= 1225 - 1330 timmar). 
            Då finns utrymmer för marknadsföring, sälj, administration, egen utveckling och mera. 
          </p>

          <p className="heading3 mt-4">
            Kostnader
          </p>
          <p>
            Håll koll på hur du använder tiden och bedöm kritiskt nödvändigheten av varje möte, samtal, mingel och ifall de verkligen 
            bidrar till ditt företags lönsamhet.  
          </p>
          <p>
            När du säljer din egen tid så är oftast dom rörliga kostnaderna ganska små även om arbets- och föreläsningsmaterial, 
            resor, uppehälle och traktamenten har sin kostnad, att betalas av kunden. Sådana kostnader faktureras bäst på ”egna rader” 
            i fakturan. Ett tillvägagångssätt som är accepterat i de flesta branscher.
          </p>
        </div>

        <p className="heading2 mt-4">
          Sälja Produkter   
        </p>
        <p>
          Om du själv tillverkar dina produkter eller om du anlitar/ingår i större produktionsapparat så är det ungefär samma områden 
          som behöver analyseras för att hitta de åtgärder som krävs för att förbättra lönsamheten - och därmed din egen lön   
        </p>
        <ul>
          <li> Rörliga kostnader </li>
          <li className="mt-1"> Ställtider (för att ställa om till/förbereda ett produktionstillfälle) </li>
          <li className="mt-1"> Inköpskostnader för verktyg (slits och förbrukas) </li>
          <li className="mt-1"> Kassation och spill </li>
          <li className="mt-1"> Linhastigheter (antal producerade enheter per timme) </li>
          <li className="mt-1">
            Utnyttjandegraden i produktion (antal timmar du/maskinerna producerar och antal timmar det står still - i timmar 
            och/eller % av tillgänglig tid) 
          </li>
          <li className="mt-1"> Fasta kostnader </li>
          <li className="mt-1">
            Bundet kapital i verksamheten i form av 
            <ul>
              <li className="mt-1"> Likvida medel i kassa och bank (kan banklån omförhandlas?) </li>
              <li className="mt-1"> Kundfordringar (kan exempelvis betalningsperioder kortas) </li>
              <li className="mt-1"> Råmaterial (ersättningsmaterial, billigare leverantör, större inköp) </li>
              <li className="mt-1"> Produkter i arbete (kan tillverkningstiden kortas?) </li>
              <li className="mt-1"> Färdig-lager (kan lagertider kortas, ”hyllvärmare” elimineras/realiseras) </li>
              <li className="mt-1"> Anläggningstillgångar (maskiner, verktyg, fastigheter, patent) </li>
            </ul>
          </li>
        </ul>
        <p>
          <span className="strong"> Kommentar: </span><br/>
          För att <i>sänka värdena</i> på förråd, lager mm väger du kostnader för att ha kapitalet bundet (i lager) mot vad du kan tjäna 
          på de kvantitetsrabatter som leverantörer erbjuder – alltså hur mycket billigare lagret kan fyllas om du köper större 
          kvantiteter mot den räntekostnad det innebär att ha kapital bundet i eget lager.  
        </p>
        <p>
          Det är speciellt i konjunkturlägen med <i>låga räntekostnader</i> som du utnyttjar leverantörens kvantitetsrabatter för att 
          fylla upp lagret och i perioder av höga räntekostnader som du krymper och ”friserar” lagerhållningen. Det finns enkla/bra 
          lageroptimeringsverktyg som kan hjälpa dig fatta lönsammaste besluten
        </p>
        <p>
          I ett större perspektiv kan frågan ställas hur mycket effektivare det lagerbundna kapitalet kan bidra till företagets 
          lönsamhet ifall det istället investeras i marknadsföring, produktutveckling, utrustning, personal, utbildning - alltså  
          hur alternativen för kapitalutnyttjandet ser ut i när- och framtid. 
        </p>

        <p className="heading2 mt-4">
          Modellera en lönsammare affär    
        </p>
        <p>
          Läs gärna igenom hjälptexterna och betrakta sedan din affärsmodell med fräsha ögon. 
        </p>

        <img
          src={DrOsterwalder}
          alt="imag"
          className="img-fluid max-width:100% height:auto mx-auto d-block"
        />
  
        <p className="imagetext">
          Hur vill du öka firmans intäkter, sänka kostnader och effektivisera din verksamhet och affär? 
        </p>

      </div>
    </>
  );
}
export default Text8;